import Cookies from 'js-cookie';

import { withForterHeaders } from 'state/graphql/links/with-forter-headers';

export const getForterToken = () => {
  const cookieForterToken = Cookies.get('forterToken');
  return withForterHeaders.ttiForterToken ?? cookieForterToken;
};

interface ICreateScanAndPayBarcode {
  baseBarcode?: string;
  forterToken?: string;
  paymentMethodId?: string;
  userId?: string;
}

export const createScanAndPayBarcode = ({
  baseBarcode = '',
  forterToken = '',
  paymentMethodId = '',
  userId = '',
}: ICreateScanAndPayBarcode) => {
  return `${baseBarcode}$U${userId}|P${paymentMethodId}|F${forterToken}`;
};

export const createBaseBarcode = (barcode?: string = '') => {
  return barcode ? `${barcode}|SR` : '';
};
